
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import eventTrackingFamilySiteProductCardsMixins from '~/mixins/eventTrackingFamilySiteProductCardsMixins';

export default {
  name: 'HappyKidsHomePageProductSection',

  mixins: [eventTrackingMixins, eventTrackingFamilySiteProductCardsMixins],

  props: {
    data: {
      type: Object,
      default: () => ({
      }),
    },
    dataIndex: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    productData() {
      return {
        dataIndex: this.dataIndex,
        productData: this.data,
        carouselCustomSetting: {
          slidesToShow: 4,
        }
      }
    }
  },
}
